import { PropAsset } from './PropAsset';

// Rock - Kaya (Canvas2D)
export class Rock extends PropAsset {
  readonly id = 'rock';
  readonly width = 40;
  readonly height = 32;
  readonly walkable = false;
  readonly collisionRadius = 0.3;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, variant?: number): void {
    const size = 8 + (variant || 0) * 4; // Size varies by variant

    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, size * s, (size / 2) * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Rock body - Kaya gövdesi
    ctx.fillStyle = '#6a6a6a';
    ctx.beginPath();
    ctx.moveTo(cx - size * s, cy - 3 * s);
    ctx.lineTo(cx - (size - 2) * s, cy - (size + 3) * s);
    ctx.lineTo(cx + (size - 4) * s, cy - (size + 5) * s);
    ctx.lineTo(cx + size * s, cy - 4 * s);
    ctx.lineTo(cx + (size - 2) * s, cy - 2 * s);
    ctx.closePath();
    ctx.fill();

    // Highlight - Parlak kısım
    ctx.fillStyle = '#8a8a8a';
    ctx.beginPath();
    ctx.moveTo(cx - (size - 2) * s, cy - (size + 3) * s);
    ctx.lineTo(cx, cy - (size) * s);
    ctx.lineTo(cx + (size - 4) * s, cy - (size + 5) * s);
    ctx.closePath();
    ctx.fill();

    // Dark edge - Karanlık kenar
    ctx.fillStyle = '#4a4a4a';
    ctx.beginPath();
    ctx.moveTo(cx + size * s, cy - 4 * s);
    ctx.lineTo(cx + (size - 2) * s, cy - 2 * s);
    ctx.lineTo(cx - size * s, cy - 3 * s);
    ctx.lineTo(cx - (size - 3) * s, cy - 5 * s);
    ctx.closePath();
    ctx.fill();

    // Specular highlight for 3D depth - Parlak nokta
    ctx.fillStyle = 'rgba(180, 180, 180, 0.3)';
    ctx.beginPath();
    ctx.ellipse(
      cx - (size * 0.2) * s,
      cy - (size + 1) * s,
      3 * s, 2 * s,
      -0.3, 0, Math.PI * 2
    );
    ctx.fill();

    // Ambient occlusion shadow at base - Taban gölgesi
    ctx.fillStyle = 'rgba(0, 0, 0, 0.12)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 1 * s, (size + 1) * s, 3 * s, 0, 0, Math.PI * 2);
    ctx.fill();
  }
}
